/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

export default {
  name: 'contentTask',
  methods: {
    toString() {
      return `ContentTask {id: "${this.id}"}`;
    }
  },
  relations: {
    belongsTo: {
      layout: {
        localField: 'layout',
        localKey: 'layoutId'
      },
      medium: {
        localField: 'medium',
        localKey: 'mediumId'
      },
      playlist: {
        localField: 'playlist',
        localKey: 'playlistId'
      }
    }
  }
};
